import M$plugin$Manageise from 'C:/proyectos/manageise/src/facade/js/manageise';
import M$control$ManageiseControl from 'C:/proyectos/manageise/src/facade/js/manageisecontrol';
import M$impl$control$ManageiseControl from 'C:/proyectos/manageise/src/impl/ol/js/manageisecontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.Manageise = M$plugin$Manageise;
window.M.control.ManageiseControl = M$control$ManageiseControl;
window.M.impl.control.ManageiseControl = M$impl$control$ManageiseControl;
